<template>
    <page :busy="busy" :tabs="tabs">
        <b-container fluid>
            <b-row>
                <b-col cols="12" sm="8" md="6" xl="4">
                    <div>
                        <h4 class="mt-3">SMS Mass Messaging Feature Forthcoming</h4>
                        <label>
                            A SMS mass messaging feature is forthcoming. This enhancement is intended to improve
                            communication and engagement with guests. We appreciate your patience and will share more
                            information as it becomes available.
                        </label>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </page>
</template>

<script>
    import Page from '../generic/page/page.vue';
    import ResponsiveButton from '../generic/responsive-button/responsive-button.vue';

    export default {
        name: 'SMSGatewaySetup',
        components: {
            Page,
            ResponsiveButton,
        },
        data() {
            return {
                busy: false,
            };
        },
        computed: {
            tabs() {
                return [
                    {
                        title: 'SMS Gateway Setup',
                        route: '/app/sms/gateway/',
                        active: false,
                    },
                    {
                        title: 'SMS Messaging',
                        route: '/app/sms/send-message/',
                        active: true,
                    },
                ];
            },
        },
        async mounted() {},
        methods: {},
    };
</script>
